// @ts-nocheck
export const localeCodes =  [
  "de",
  "en",
  "es",
  "fr",
  "it",
  "pt"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_45DE_46json_e99b12aa",
      load: () => import("#nuxt-i18n/e99b12aa" /* webpackChunkName: "locale_de_45DE_46json_e99b12aa" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45GB_46json_81439e26",
      load: () => import("#nuxt-i18n/81439e26" /* webpackChunkName: "locale_en_45GB_46json_81439e26" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_077ff8a8",
      load: () => import("#nuxt-i18n/077ff8a8" /* webpackChunkName: "locale_es_45ES_46json_077ff8a8" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_e7a9ad08",
      load: () => import("#nuxt-i18n/e7a9ad08" /* webpackChunkName: "locale_fr_45FR_46json_e7a9ad08" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_441d2f8a",
      load: () => import("#nuxt-i18n/441d2f8a" /* webpackChunkName: "locale_it_45IT_46json_441d2f8a" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45BR_46json_cd596b75",
      load: () => import("#nuxt-i18n/cd596b75" /* webpackChunkName: "locale_pt_45BR_46json_cd596b75" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    _hreflang: "de-DE",
    _sitemap: "de-DE"
  },
  {
    code: "en",
    language: "en-GB",
    name: "English",
    _hreflang: "en-GB",
    _sitemap: "en-GB"
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    _hreflang: "es-ES",
    _sitemap: "es-ES"
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  },
  {
    code: "pt",
    language: "pt-BR",
    name: "Português",
    _hreflang: "pt-BR",
    _sitemap: "pt-BR"
  }
]
/** client **/

/** client-end **/